module.exports = __webpack_public_path__ + "49c9f2d579693086c46ac779ac6e5bb7.jpg";